<template>
  <div class="case-detail-gene-mastermind-data-page col-block width-full" :style="{ flex: 1 }">
    <template v-if="!errorMessage">
      <div class="data-container col-block width-full" v-for="(variant, vindex) in variants" :key="vindex">
        <div class="data-title-container row-block">
          <div class="data-title">{{ [variant.Feature, variant.HGVSc].filter(x => x).join(':') || (variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -') }}</div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div :style="{ height: '10px' }"></div>
        <div class="data-content-container col-block width-full">
          <div class="data-content-block col-block width-full" v-for="(optionGroup, gindex) in tableOptionGroups" :key="gindex">
            <div class="data-row-container col-block width-full">
              <div class="data-row row-block stretch">
                <div class="data-col col-block" v-for="(option, oindex) in optionGroup.options" :key="oindex" :class="[option.position]" :style="option.width ? { width: option.width } : { flex: 1 }">
                  <div :style="{ flex: 1 }"></div>
                  <div class="data-content" v-html="option.title"></div>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
              <div class="data-row row-block stretch" v-for="(mastermind, mindex) in variant.mastermindDatas" :key="mindex">
                <div class="data-col col-block" v-for="(option, oindex) in optionGroup.options" :key="oindex" :class="[option.position]" :style="option.width ? { width: option.width } : { flex: 1 }">
                  <div :style="{ flex: 1 }"></div>
                  <div class="data-content" :class="{ link: option.value(mastermind, mindex, vindex, variants) && option.func }" :style="option.style ? option.style(mastermind, mindex, vindex, variants) : {}" v-html="option.value(mastermind, mindex, vindex, variants) || option.empty || '- -'" @click="e => (option.func || (() => {}))(mastermind, mindex, vindex, variants)"></div>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedPublication" class="publication-detail-container col-block width-full">
        <div class="publication-detail-title-container row-block">
          <div class="publication-detail-title" v-html="$t('COMPONENT.caseDetail.geneMastermindData.table.publication.___title', { count: selectedPublication.index, variant: selectedPublication.variant })"></div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div :style="{ height: '10px' }"></div>
        <keep-alive>
          <mastermindPublicationTable
            :key="selectedPublication.id"
            :pmids="selectedPublication.pmids"
          ></mastermindPublicationTable>
        </keep-alive>
      </div>
      <div :style="{ height: 0 }"></div>
    </template>
    <template v-else>
      <div class="mastermind-error-message">{{ errorMessage }}</div>
      <div :style="{ height: '20px' }"></div>
    </template>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <button v-if="Object.values(param.unlockState).some(state => state === false)" class="main-button circle-button" @click="e => unlockMastermind()">
        <span>{{ $t('COMMON.button.___unlock') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import mastermindPublicationTable from '../case/mastermindPublicationTable.vue'
import toastMethods from '../../mixins/toastMethods.vue'
import { defaultEmptyDisplay, clinvarACMGMap } from '../../constants/global/data'

export default {
  components: {
    mastermindPublicationTable
  },
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      selectedPublication: null
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    errorMessage () {
      let unlockState = this.param.unlockState
      if (!unlockState['project']) return this.$t('COMPONENT.caseDetail.geneMastermindData.___lockAlert')
      if (!unlockState['case'] && !['supervisor'].includes(this.user.role)) return this.$t('COMPONENT.caseDetail.geneMastermindData.___lockAlert')
    },
    // static
    tableOptionGroups () {
      const mastermind = {
        title: this.$t('COMPONENT.caseDetail.geneMastermindData.table.mastermind.___title'),
        options: [
          {
            title: this.$t('COMPONENT.caseDetail.geneMastermindData.table.mastermind.title.___report'),
            value: (mastermind, index, vindex, variants) => this.getMastermindIndex(mastermind, index, vindex, variants),
            style: null,
            width: '60px',
            position: 'center',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneMastermindData.table.mastermind.title.___classification'),
            value: (mastermind) => {
              if (!mastermind.classification) return null
              let classificationData = clinvarACMGMap[(mastermind.classification[0].toUpperCase() + mastermind.classification.slice(1)).replace(/_/g, ' ')] || clinvarACMGMap[mastermind.classification]
              return classificationData ? this.$t(classificationData.title) : ((mastermind.classification[0].toUpperCase() + mastermind.classification.slice(1)).replace(/_/g, ' '))
            },
            style: (mastermind) => {
              if (!mastermind.classification) return null
              const defaultStyles = { 'font-weight': 'bold' }
              let classificationData = clinvarACMGMap[(mastermind.classification[0].toUpperCase() + mastermind.classification.slice(1)).replace(/_/g, ' ')] || clinvarACMGMap[mastermind.classification]
              return {
                ...defaultStyles,
                ...(classificationData ? { color: classificationData.color } : null)
              }
            },
            width: '232px',
            position: 'center',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneMastermindData.table.mastermind.title.___variantIdentifiers'),
            value: (mastermind) => mastermind.id,
            style: null,
            position: 'center',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneMastermindData.table.mastermind.title.___publications'),
            value: (mastermind) => {
              if (!mastermind.pmid) return null
              let pmidCount = mastermind.pmid.split(',').length
              return this.$tc('COMPONENT.caseDetail.geneMastermindData.table.mastermind.value.___publications', pmidCount, { count: pmidCount })
            },
            style: null,
            width: '292px',
            position: 'center',
            empty: this.$t(defaultEmptyDisplay.empty),
            func: (mastermind, index, vindex, variants) => {
              let mindex = this.getMastermindIndex(mastermind, index, vindex, variants)
              let variant = variants[vindex]
              this.setPublication(mastermind, mindex, variant)
            }
          }
        ]
      }
      return [
        mastermind
      ].filter(x => x)
    },
    // param
    gene () {
      return this.param.gene
    },
    variants () {
      return Object.keys(this.param.variants).map(vkey => {
        let variant = this.param.variants[vkey]
        let ids = (variant.Mastermind_MMID3 || []).filter(x => x)
        let classifications = (variant.Mastermind_Classification || []).filter(x => x)
        let pmids = (variant.Mastermind_PMID || []).filter(x => x)
        return {
          ...variant,
          vkey,
          mastermindDatas: ids.length ? ids.map((_, index) => ({ id: ids[index], classification: classifications[index], pmid: pmids[index] })) : [{}]
        }
      })
    }
  },
  created () {
    if ((this.param.mastermind || {}).defaultPublication) {
      let index = 0
      for (let variant of this.variants.filter(variant => variant.mastermindDatas[0].id)) {
        for (let mastermindData of variant.mastermindDatas) {
          index++
          if (mastermindData.id === this.param.mastermind.defaultPublication) {
            this.setPublication(mastermindData, index, variant)
          }
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'setModal2Action',
      'setLoadingAction'
    ]),
    getMastermindIndex (mastermind, index, vindex, variants) {
      if (!mastermind.id) return null
      let mastermindCount = variants.slice(0, vindex).filter(variant => variant.mastermindDatas[0].id).reduce((count, variant) => count + variant.mastermindDatas.length, 0)
      return mastermindCount + index + 1
    },
    setPublication (mastermind, index, variant) {
      this.selectedPublication = { index, id: mastermind.id, pmids: mastermind.pmid.split(','), variant: [variant.Feature, variant.HGVSc].filter(x => x).join(':') || (variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -') }
    },
    unlockMastermind () {
      let ownerName = [this.param.owner.first_name, this.param.owner.last_name].filter(x => x).join(' ') + '(' + this.param.owner.email + ')'
      let message = [
        this.$t('COMPONENT.caseDetail.geneMastermindData.modal.content.___unlockReanalyzeForOwner', { owner: ownerName }),
        this.$t('COMPONENT.caseDetail.geneMastermindData.modal.content.___unlockReanalyze'),
        this.$t('COMPONENT.caseDetail.geneMastermindData.modal.content.___unlockReloadForOwner', { owner: ownerName }),
        this.$t('COMPONENT.caseDetail.geneMastermindData.modal.content.___unlockReload')
      ][(this.param.owner.id === this.user.id ? 1 : 0) + (this.param.unlockState['project'] ? 2 : 0)]
      this.setModal2Action({
        action: 'toast',
        width: '496px',
        customStyles: {
          padding: 0,
          border: 0
        },
        param: {
          type: 'normal',
          content: message,
          buttons: [
            {
              title: this.$t('COMMON.button.___cancel'),
              type: 'gray',
              result: false
            },
            {
              title: this.$t('COMMON.button.___apply'),
              type: 'main',
              result: true
            }
          ]
        },
        callback: async result => {
          if (result) {
            this.setLoadingAction(true)
            await this.param.unlockMastermind()
            if (this.param.unlockState['project']) {
              location.reload()
            } else {
              this.$emit('changeModal')
              this.setLoadingAction(false)
            }
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/caseDetail/geneMastermindData.vue